'use client'

import { buildHomeUrl, BuildHomeUrlParams } from '../builders/home-url'

export const useHomeUrl = (options: BuildHomeUrlParams = {}): string => {
  return buildHomeUrl(options)
}
